import { APIClient } from "../../helpers/apiClient";
import { isPublisher } from "../../helpers/checkRoles";

import IconMantra from "../../assets/images/icon-mantra2.png";

import {
  SET_TEMPLATES,
  SET_ACTIVE_SIDEBAR_TAB,
  GET_TEMPLATES,
  SEND_TEMPLATE,
  CHANGE_VIEW_TEMPLATES,
  CHANGE_USER_IN_TEMPLATES,
  SET_WA_TEMPLATES,
  SET_SORTED_TEMPLATES,
  CHANGE_EDIT_WA_TEMPLATE_ID,
} from "./constants";
import { isIOS } from "../../helpers/checkBrowser";

const apiClient = new APIClient();
const { get, create, put, remove, patch } = apiClient;

export const setTemplates = (contacts) => {
  return {
    type: SET_TEMPLATES,
    payload: contacts,
  };
};

export const getTemplates = () => async (dispatch, getState) => {
  try {
    const currentGroup = getState().Group.currentGroup;
    if (currentGroup) {
      const { id: groupId } = currentGroup;
      const response = await get("/templates", { params: { groupId, withArchived: true } });
      const currentGroupId = getState().Group.currentGroup?.id;
      if (currentGroupId === groupId) {
        dispatch(setTemplates(response));
      }
    }
  } catch (e) {
    console.log(e);
  }
};

export const sendTemplate = (templateId) => async (dispatch, getState) => {
  const isReadOnly = getState().Auth?.permissionsCurrentGroup?.isReadOnly;
  if (isReadOnly) return;

  const {
    currentGroup: { id: groupId },
  } = getState().Group;
  const activeContact = getState().Contact.activeContact;

  try {
    await apiClient.postToMessageApi(
      `/templates`,
      {
        contactId: activeContact.id,
        templateId,
      },
      {
        headers: { GroupId: groupId },
      }
    );
  } catch (error) {
    console.log(error);
  }
};

export const archiveTemplate = (templateId) => async (dispatch, getState) => {
  try {
    const currentGroupId = getState().Group.currentGroup?.id;
    await put(`/templates/${templateId}/archived`);
    const currentGroupIdAfterReq = getState().Group.currentGroup?.id;
    const templates = getState().Templates.templates;
    const newTemplates = templates.map((template) => {
      if (template.id === templateId) {
        return {
          ...template,
          archived: true,
        };
      }
      return template;
    });
    if (currentGroupIdAfterReq === currentGroupId) dispatch(setTemplates(newTemplates));
  } catch (error) {
    console.log(error);
  }
};

export const unarchiveTemplate = (templateId) => async (dispatch, getState) => {
  try {
    const currentGroupId = getState().Group.currentGroup?.id;
    await remove(`/templates/${templateId}/archived`);
    const currentGroupIdAfterReq = getState().Group.currentGroup?.id;

    if (currentGroupIdAfterReq === currentGroupId) {
      const templates = getState().Templates.templates;
      const newTemplates = templates.map((template) => {
        if (template.id === templateId) {
          return {
            ...template,
            archived: false,
          };
        }
        return template;
      });
      dispatch(setTemplates(newTemplates));
    }
  } catch (error) {
    console.log(error);
    if (error && error.includes("409"))
      throw Error("WATEMPLATE_NOT_APPROVED");
    else
      throw Error("Error desarchivando plantilla");
  }
};

export const changeViewTemplates = (payload) => ({
  type: CHANGE_VIEW_TEMPLATES,
  payload,
});

export const changeUserInTemplates = (payload) => ({
  type: CHANGE_USER_IN_TEMPLATES,
  payload,
});

export const setWaTemplates = (templates) => {
  return {
    type: SET_WA_TEMPLATES,
    payload: templates,
  };
};

export const getWaTemplates = () => async (dispatch, getState) => {
  try {
    const currentGroup = getState().Group.currentGroup;
    if (currentGroup) {
      const { id: groupId } = currentGroup;
      const response = await get("/watemplates", { params: { groupId } });
      const currentGroupIdAfterReq = getState().Group.currentGroup?.id;
      if (currentGroupIdAfterReq === groupId) dispatch(setWaTemplates(response));
    }
  } catch (e) {
    console.log(e);
  }
};

export const applyTemplate = (payload) => async (dispatch, getState) => {
  const {
    currentGroup: { id: groupId },
  } = getState().Group;
  const {
    name,
    type,
    text,
    example,
    category,
    buttons,
    approveCtaButtonValue,
    file,
    header,
    footer,
    allowCategoryChange,
    enableLinkTracking,
    languageCode,
    addSecurityRecommendation,
    codeExpirationMinutes,
  } = payload;
  try {
    let template;
    let approveText = "";
    let newText = text;
    if (text) {
      approveText = text;
      const matches = text.match(/\{\{[^{}]+\}\}/g) || [];
      matches.forEach((match, index) => {
        newText = newText.replace(match, `{{${index + 1}}}`);
      });
    }
    if(payload.category === 'MARKETING' && payload.type === 'CAROUSEL') {
      let currentCards = [];
      for (var i = 0; i < payload.carouselCards.length; i++) {
        // Esperar a que cada iteración complete completamente antes de continuar
        try {
          // Paso 1: Crear FormData y subir el archivo, esperar respuesta
          let urlMedia;
          if (payload.carouselCards[i]?.mediaUrl) {
            urlMedia = { url: payload.carouselCards[i].mediaUrl };
          } else {
            const formData = new FormData();
            const fileToUpload = payload.files && payload.files[i] ? payload.files[i] : payload.carouselCards[i]?.file;
            if (!fileToUpload) {
              throw new Error(`No file found for carousel card ${i}`);
            }
            formData.append("media", fileToUpload);
            urlMedia = await create("/files", formData);
            if (!urlMedia || !urlMedia.url) {
              throw new Error(`Failed to create media URL for carousel card ${i}`);
            }
          }

          // Paso 2: Mapear botones: transformar URLs dinámicas (después de que urlMedia esté listo)
          const mappedButtons = payload.carouselCards[i].buttons.map(button => {
            if (button.type === 'QUICK_REPLY') {
              return button;
            }

            // Botón dinámico: transformar URL dinámica
            if (button.type === 'URL' && button.urlType === 'dynamic') {
              // Encontrar la variable {{variable}} en la URL
              const variableMatch = button.url.match(/\{\{([^}]+)\}\}/);
              if (variableMatch) {
                const variableName = variableMatch[0]; // {{name}}
                const buttonValue = button.url.replace(variableName, ''); // https://app.slack.com/client/
                const suffix = button.example.replace(buttonValue, '');
                const mappedUrl = button.url.replace(variableName, '{{1}}');
                
                const mappedButton = {
                  type: button.type,
                  text: button.text,
                  url: mappedUrl,
                  approveTextUrl: button.url,
                  buttonValue: buttonValue,
                  suffix: suffix,
                  example: [button.example]
                };
                
                return mappedButton;
              }
            }
            
            // Botón estático o QUICK_REPLY: pasar sin transformación adicional
            const staticButton = {
              type: button.type,
              text: button.text,
              url: button.url,
              approveTextUrl: button.url,
              buttonValue: button.url,
              suffix: "",
              example: [button.url]
            };
            return staticButton;
          });

          // Paso 3: Procesar approveBody (después de que urlMedia esté listo)
          let approveBody = payload.carouselCards[i].body;
          const matches = approveBody.match(/\{\{[^{}]+\}\}/g) || [];
          matches.forEach((match, index) => {
            approveBody = approveBody.replace(match, `{{${index + 1}}}`);
          });

          // Paso 4: Agregar a currentCards (después de que todo esté procesado y urlMedia esté listo)
          currentCards.push({
            headerType: "IMAGE",
            mediaUrl: urlMedia.url,
            body: approveBody,
            sampleText: payload.carouselCards[i].example,
            approveBody: payload.carouselCards[i].body,
            buttons: mappedButtons,
          });
          
          // Esta iteración ha completado, el for loop continuará con el siguiente índice
        } catch (error) {
          console.error(`Error processing carousel card ${i}:`, error);
          throw error; // Detener el proceso si hay un error en cualquier iteración
        }
      }

      const body = {
        groupId,
        name,
        templateType: type,
        templateText: newText,
        templateApproveText: approveText,
        example: example,
        category: category,
        languageCode: languageCode,
        cards: currentCards,
      };
      template = await create("/watemplates/apply", body);
    }
    else if (['IMAGE', 'VIDEO', 'DOCUMENT'].includes(type)) {
      if (!file) throw Error('FILE_REQUIRED');
      const formData = new FormData();
      formData.append("media", file);
      const urlMedia = await create("/files", formData);
      const media = urlMedia.url;

      if(type === "DOCUMENT"){
        const file = {
          media: "https://i101219twsp-production.s3.us-east-2.amazonaws.com/storage/bbf67bf8-f8bf-4525-bc07-b64be063a697.pdf",
          type: "PDF"
        };
        formData.append("media", file);
      }

      formData.append("groupId", groupId);
      formData.append("name", name);
      formData.append("templateType", type);
      formData.append("templateText", newText);
      formData.append("templateApproveText", approveText);
      formData.append("approveCtaButtonValue", approveCtaButtonValue);
      formData.append("media", media);
      formData.append("example", example);
      formData.append("category", category);
      formData.append("languageCode", languageCode);
      if (buttons) {
        formData.append("buttons", JSON.stringify(buttons));
      }
      if (footer)
        formData.append("footer", footer);
      if (!!allowCategoryChange)
        formData.append("allowCategoryChange", !!allowCategoryChange);
      if (!!enableLinkTracking)
        formData.append("enableLinkTracking", !!enableLinkTracking);
      if (category === 'AUTHENTICATION' && addSecurityRecommendation !== undefined)
        formData.append("addSecurityRecommendation", !!addSecurityRecommendation);
      if (category === 'AUTHENTICATION' && codeExpirationMinutes !== undefined)
        formData.append("codeExpirationMinutes", codeExpirationMinutes);
      template = await create("/watemplates/apply-media", formData);
    } else if (type == 'TEXT') {
      template = await create("/watemplates/apply", {
        groupId,
        name,
        templateType: type,
        templateText: newText,
        templateApproveText: approveText,
        approveCtaButtonValue: approveCtaButtonValue,
        media: "",
        example,
        category,
        buttons,
        languageCode,
        ...(header && { header }),
        ...(footer && { footer }),
        ...(allowCategoryChange && { allowCategoryChange }),
        ...(enableLinkTracking && { enableLinkTracking }),
        ...(category === 'AUTHENTICATION' && addSecurityRecommendation !== undefined && { addSecurityRecommendation }),
        ...(category === 'AUTHENTICATION' && codeExpirationMinutes !== undefined && { codeExpirationMinutes }),
      });
    } else {
      throw Error("Error setting type of template");
    }
    const currentGroupIdAfterReq = getState().Group.currentGroup?.id;
    const waTemplates = getState().Templates.waTemplates;
    if (template && template.id && currentGroupIdAfterReq === groupId) {
      const newWaTemplates = [template, ...waTemplates];
      dispatch(setWaTemplates(newWaTemplates));
    }
  } catch (error) {
    console.log(error);
    if (error.message === 'FILE_REQUIRED') throw Error('Archivo adjunto es requerido');
    throw Error("Error applying new template");
  }
};

export const registerTemplate = (payload) => async (dispatch, getState) => {
  const currentGroup = getState().Group.currentGroup;
  const { name, content, gsId, file } = payload;
  try {
    // Para carousel, las cards ya vienen con mediaUrl configurado (archivos ya subidos en ModalRegisterTemplate)
    // Solo usar las cards tal cual vienen
    if (content.type === 'carousel' && content.cards && Array.isArray(content.cards)) {
      // Las cards ya tienen mediaUrl configurado, no necesitan procesamiento adicional
      content.cards = content.cards;
    } else if (file) {
      // Manejo normal para otros tipos de templates
      const formData = new FormData();
      formData.append("media", file);
      const urlMedia = await create("/files", formData);
      content.media = urlMedia.url;
    }
    
    const template = await create("/templates", {
      groupId: currentGroup.id,
      name,
      content,
      gsId,
    });
    const currentGroupIdAfterReq = getState().Group.currentGroup?.id;
    const templates = getState().Templates.templates;
    if (template && template.id && currentGroupIdAfterReq === currentGroup.id) {
      const newTemplates = [...templates, template];
      dispatch(setTemplates(newTemplates));
    }
  } catch (error) {
    console.log(error);
    throw Error("Error registering new template");
  }
};

export const newTemplate = (payload) => async (dispatch, getState) => {
  try {
    const currentGroup = getState().Group.currentGroup;
    const templates = getState().Templates.templates;
    if (payload && payload.id && payload.groupId === currentGroup.id && !templates.find((template) => template?._id === payload.id)) {
      const newTemplates = [...templates, payload];
      dispatch(setTemplates(newTemplates));
    }
  } catch (error) {
    console.log(error);
    throw Error("Error registering new template");
  }
};

export const newTemplateQualityStatus = (payload) => async (dispatch, getState) => {
  try {
    const waTemplates = getState().Templates.waTemplates;
    const foundTemplate = waTemplates.find(t => t.id === payload.waTemplateId);
    if (foundTemplate) foundTemplate.quality = payload.quality;
    dispatch(setWaTemplates([...waTemplates]));
  } catch (error) {
    console.log(error);
    throw Error("Error registering new watemplate quality status");
  }
};

export const editTemplate =
  (templateId, payload) => async (dispatch, getState) => {
    try {
      const currentGroupId = getState().Group.currentGroup?.id;
      const { name, content, gsId, order, file, cards } = payload;
      if (file) {
        const formData = new FormData();
        formData.append("media", file);
        const urlMedia = await create("/files", formData);
        content.media = urlMedia.url;
      }
      const template = await patch(`/templates/${templateId}`, {
        name,
        content: {
          text: content.text,
          type: content.type,
          media: content.media,
          ...(content.filename && { filename: content.filename }),
        },
        ...(content.type === 'carousel' && cards && { cards: cards }),
        gsId,
        order,
      });
      const currentGroupIdAfterReq = getState().Group.currentGroup?.id;
      const templates = getState().Templates.templates;
      if (template && template.id && currentGroupIdAfterReq === currentGroupId) {
        const newTemplates = templates.map((t) =>
          t.id == template.id ? template : t
        );
        dispatch(setTemplates(newTemplates));
      }
    } catch (error) {
      console.log(error);
      throw Error("Error updating template");
    }
  };

export const deleteWaTemplate = (templateId) => async (dispatch, getState) => {
  try {
    const currentGroupId = getState().Group.currentGroup?.id;
    await remove(`/watemplates/${templateId}`);
    const currentGroupIdAfterReq = getState().Group.currentGroup?.id;
    const waTemplates = getState().Templates.waTemplates;
    if (currentGroupIdAfterReq === currentGroupId) {
      const newWaTemplates = waTemplates.filter((t) => t.id !== templateId);
      dispatch(setWaTemplates(newWaTemplates));
    }
  } catch (error) {
    console.log(error);
    throw Error("Error deleting template");
  }
};

export const updateTemplateStatus = (payload) => async (dispatch, getState) => {
  try {
    const { templateId, status, category } = payload;
    const waTemplates = getState().Templates.waTemplates;
    const foundTemplate = waTemplates.find((t) => t.id == templateId);
    if (foundTemplate) {
      const newWaTemplates = waTemplates.map((template) => {
        if (template.id === templateId) {
          return {
            ...template,
            status,
            ...(template.category != category && {
              category,
              prevCategory: template.category,
              showPrevCategory: true,
            }),
          };
        }
        return template;
      });
      dispatch(setWaTemplates(newWaTemplates));
      if (status === "approved" || status === "rejected") {
        if (isIOS()) return;
        let notification = new Notification(
          `Plantilla ${status === "approved" ? "aprobada" : "rechazada"}`,
          {
            icon: IconMantra,
            body: `Nombre: ${foundTemplate.name}`,
          }
        );
        notification.onclick = function (e) {
          e.preventDefault();
          window.focus();
          notification.close();
        };
      }
      if (
        (foundTemplate.status === 'approved' && ['rejected', 'deleted', 'disabled', 'paused'].includes(status)) ||
        (foundTemplate.status === 'paused' && status === 'approved')
      ) {
        const templates = getState().Templates.templates;
        let _templatesToUpdate = foundTemplate.status === 'approved' ?
          templates.filter(t => t.gsId === foundTemplate.gsId && !t.archived) :
          templates.filter(t => t.gsId === foundTemplate.gsId && !!t.archived);
        if (_templatesToUpdate.length) {
          dispatch(getTemplates());
          dispatch(getSortedTemplates());
        }
      }
    }
  } catch (error) {
    console.log(error);
    throw Error("Error updating template status");
  }
};

export const setSortedTemplates = (contacts) => {
  return {
    type: SET_SORTED_TEMPLATES,
    payload: contacts,
  };
};

export const getSortedTemplates = () => async (dispatch, getState) => {
  const currentGroup = getState().Group.currentGroup;
  try {
    const templates = await apiClient.get(
      `/templates/bypositions?groupId=${currentGroup.id}`
    );
    const currentGroupIdAfterReq = getState().Group.currentGroup?.id;
    if (Array.isArray(templates) && templates.length > 0 && currentGroupIdAfterReq === currentGroup.id) {
      const filteredTemplates = templates.filter(
        (template) => !template.archived
      );
      dispatch(setSortedTemplates(filteredTemplates));
    }
  } catch (error) {
    console.log(error);
    throw Error("Error ordering templates");
  }
};

export const setActiveSidebarTab = (tab) => ({
  type: SET_ACTIVE_SIDEBAR_TAB,
  payload: tab,
});

export const getWaTemplatesSync = () => async (dispatch, getState) => {
  try {
    const groupId = getState().Group.currentGroup?.id;
    if (groupId) {
      const response = await get("/watemplates/sync", { params: { groupId } });
      const currentGroupIdAfterReq = getState().Group.currentGroup?.id;

      if (currentGroupIdAfterReq === groupId && Array.isArray(response) && response.length) {
        const waTemplates = getState().Templates.waTemplates;
        const newWaTemplates = [...waTemplates], approvedTemplates = [], rejectedTemplates = [];

        for (const syncedTemplate of response) {
          if (syncedTemplate.prevStatus) {
            const template = newWaTemplates.find(t => t.id == syncedTemplate.id);
            if (template) {
              template.status = syncedTemplate.status;
              template.prevStatus = syncedTemplate.prevStatus;
              if (syncedTemplate.status === 'rejected' && syncedTemplate.payload?.reason)
                template.rejectedReason = syncedTemplate.payload.reason;

              if (template.status == 'approved')
                approvedTemplates.push(template);
              else if (template.status == 'rejected')
                rejectedTemplates.push(template);
            }
          }
        }
        dispatch(setWaTemplates(newWaTemplates));
        return {
          approvedTemplates,
          rejectedTemplates,
        };
      }
      return {};
    }
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const changeEditWaTemplateId = (id, buttons) => ({
  type: CHANGE_EDIT_WA_TEMPLATE_ID,
  payload: {
    id,
    buttons,
  },
});
